export enum Language {
  EN = 'en',
  ZH_CN = 'zh-CN',
}
